import { useState, useEffect, RefObject } from 'react';

const useIsFocused = (ref: RefObject<any>) => {
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    const el = ref?.current;
    if (!el) return;

    const handleFocusIn = () => setIsFocused(true);
    const handleFocusOut = (event: FocusEvent) => {
      if (
        event.relatedTarget instanceof Node &&
        !el.contains(event.relatedTarget)
      ) {
        setIsFocused(false);
      }
    };

    el.addEventListener('focusin', handleFocusIn);
    el.addEventListener('focusout', handleFocusOut);
    return () => {
      el.removeEventListener('focusin', handleFocusIn);
      el.removeEventListener('focusout', handleFocusOut);
    };
  }, [ref]);

  return isFocused;
};

export default useIsFocused;
